import styled from "styled-components";

export const StyledAccountDetailsFormLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;
export const StyledAccountDetailsFormLayoutInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  .bold-text {
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const StyledCurrentAccountDetailsBox = styled.div`
  max-width: fit-content;
  border: 1px solid #f0f0f0;
  padding: 1rem;
  border-radius: 5px;
  font-size: 1.4rem;

  .bold-text {
    font-weight: 600;
    font-size: 1.4rem;
  }
`;
